import { useMemo } from 'react';

import { FeedbackState } from '../types/feedback';
import { useQueryListFeedback } from './use-feedback-api';

interface Input {
	viewUserId: string;
	directReportUserId?: string | null;
}

export const useFeedbackDraftList = ({ viewUserId, directReportUserId }: Input) => {
	const { data } = useQueryListFeedback({
		userId: viewUserId,
		state: FeedbackState.Draft,
	});

	return useMemo(() => {
		if (!data || !data.evaluations) {
			return {
				draftFeedback: [],
			};
		}

		const filteredFeedback = directReportUserId
			? data.evaluations.filter((feedback) => feedback.receiverIs(directReportUserId) || feedback.giverIs(directReportUserId))
			: data.evaluations;

		return {
			draftFeedback: filteredFeedback.filter((evaluation) => {
				return (
					(evaluation.receiverIs(viewUserId) && evaluation.state === FeedbackState.DraftRequest) ||
					(evaluation.giverIs(viewUserId) && evaluation.state === FeedbackState.Draft && !!evaluation.lastDraft) ||
					(evaluation.giverIs(viewUserId) && evaluation.state === FeedbackState.Request && !!evaluation.lastDraft)
				);
			}),
		};
	}, [data, directReportUserId, viewUserId]);
};
